export default __webpack_public_path__ + "static/media/logo800.eb4c2645.png";